/**
 * @format
 */
import React, { useState } from 'react';
import { ActivityIndicator, Platform, Image } from 'react-native';
// import { Image } from 'react-native-elements';
import FastImage from 'react-native-fast-image';

type Props = {} & any;
// TODO: in the future replace this component with ZTImage from `zone-tail-library`
const ZTImage: React.FC<Props> = (props: any) => {
  const { style, uri } = props;
  let { resizeMode } = props;
  if (!resizeMode || Platform.OS === 'web') {
    resizeMode = 'cover';
  } else {
    resizeMode = FastImage.resizeMode.cover;
  }
  const [loading, setIsLoading] = useState(true);
  // console.log(`ZT IMAGE for ${uri}`);
  if (Platform.OS === 'web') {
    return (
      <Image
        source={{ uri }}
        style={style}
        {...props}
        // this seems to hang sometimes on web
        // PlaceholderContent={<ActivityIndicator />}
      />
    );
  }
  return (
    <FastImage
      source={{ uri }}
      style={style}
      onLoadStart={() => {
        setIsLoading(true);
      }}
      onLoadEnd={() => {
        setIsLoading(false);
      }}
    >
      <ActivityIndicator
        animating={loading}
        size="large"
        color={'#cccccc'}
        style={style}
      />
    </FastImage>
  );
};

export default ZTImage;
